<app-page-header title="PSP Definition" subtitle="Configure payment service provider definitions and settings">
    <div actions class="flex gap-2">
        <p-iconfield>
            <p-inputicon class="pi pi-search" />
            <input type="text" pInputText placeholder="Search" (input)="onGlobalSearch($event)" />
        </p-iconfield>
        <p-button label="Add New" (click)="openCreate()" icon="pi pi-plus"></p-button>
    </div>
</app-page-header>

<div class="table-card">
    <p-confirmpopup />
    <p-table
        #dt
        [value]="pspDefinitions"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]"
        [scrollable]="true"
        scrollHeight="flex"
        dataKey="pspType.id"
        [rowHover]="true"
        [globalFilterFields]="['pspType.text', 'pspType.type', 'pspType.method', 'pspType.tenant.name']"
        [expandedRowKeys]="expandedRows"
        (onRowExpand)="onRowExpand($event)"
        (onRowCollapse)="onRowCollapse($event)"
    >
        <ng-template pTemplate="header">
            <tr>
                <th class="w-[4rem]"></th>
                <th pSortableColumn="pspType.id" class="text-left w-[80px]">
                    <div class="flex items-center gap-2">
                        ID
                        <p-sortIcon field="pspType.id"></p-sortIcon>
                    </div>
                </th>
                <th pSortableColumn="pspType.text" class="text-left">
                    <div class="flex items-center gap-2">
                        Definition
                        <p-sortIcon field="pspType.text"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="pspType.text" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="pspType.type" class="text-left">
                    <div class="flex items-center gap-2">
                        Provider Type
                        <p-sortIcon field="pspType.type"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="pspType.type" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="pspType.method" class="text-left">
                    <div class="flex items-center gap-2">
                        Payment Method
                        <p-sortIcon field="pspType.method"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="pspType.method" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="pspType.tenant.name" class="text-left">
                    <div class="flex items-center gap-2">
                        Tenant
                        <p-sortIcon field="pspType.tenant.name"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="pspType.tenant.name" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="pspType.active" class="text-left w-[120px]">
                    <div class="flex items-center gap-2">
                        Status
                        <p-sortIcon field="pspType.active"></p-sortIcon>
                    </div>
                </th>
                <th class="w-[80px]"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-expanded="expanded">
            <tr>
                <td>
                    <p-button
                        type="button"
                        [pRowToggler]="row"
                        [text]="true"
                        [rounded]="true"
                        [plain]="true"
                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    />
                </td>
                <td>{{ row.pspType.id }}</td>
                <td>{{ row.pspType.text }}</td>
                <td>
                    @if (row.loginInfo?.length > 0) {
                        <a
                            [href]="row.loginInfo[0].deepLink"
                            target="_blank"
                            class="text-primary underline cursor-pointer"
                            (mouseenter)="showLoginPopover($event, row)"
                            (mouseleave)="hideLoginPopover()"
                        >
                            {{ row.pspType.type }}
                        </a>
                    } @else {
                        {{ row.pspType.type }}
                    }
                </td>
                <td>{{ row.pspType.method }}</td>
                <td>{{ row.pspType.tenant.name }}</td>
                <td>
                    <span [ngClass]="row.pspType.active ? 'status-badge status-active' : 'status-badge status-inactive'">
                        {{ row.pspType.active ? 'Active' : 'Inactive' }}
                    </span>
                </td>
                <td class="text-right">
                    <p-button [text]="true" severity="secondary" icon="pi pi-pencil" (click)="openEdit(row)"></p-button>
                </td>
            </tr>
        </ng-template>
        <ng-template #expandedrow let-row>
            <tr>
                <td colspan="8" class="bg-gray-100">
                    <div class="p-3">
                        <div class="flex justify-between items-center mb-3">
                            <span class="font-bold text-lg">Login Information</span>
                            <p-button
                                label="Add Login Info"
                                icon="pi pi-plus"
                                size="small"
                                (click)="openLoginCreate(row.pspType.id)"
                            ></p-button>
                        </div>
                        <p-table [value]="row.loginInfo" dataKey="id">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Deep Link</th>
                                    <th>User Name</th>
                                    <th>Password</th>
                                    <th>Additional Info</th>
                                    <th style="width: 100px"></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-login>
                                <tr>
                                    <td>
                                        <a [href]="login.deepLink" target="_blank" class="text-primary underline">{{ login.deepLink }}</a>
                                    </td>
                                    <td>
                                        <div class="flex items-center gap-2">
                                            {{ login.userName }}
                                            <i
                                                class="pi pi-copy text-primary cursor-pointer hover:text-primary-600"
                                                (click)="copyToClipboard(login.userName)"
                                            ></i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="flex items-center gap-2">
                                            {{ login.password }}
                                            <i
                                                class="pi pi-copy text-primary cursor-pointer hover:text-primary-600"
                                                (click)="copyToClipboard(login.password)"
                                            ></i>
                                        </div>
                                    </td>
                                    <td>{{ login.additionalInfo }}</td>
                                    <td class="text-right">
                                        <div class="flex gap-2 justify-end">
                                            <p-button
                                                [text]="true"
                                                severity="secondary"
                                                icon="pi pi-pencil"
                                                (click)="openLoginEdit(login, row.pspType.id)"
                                            ></p-button>
                                            <p-button
                                                [text]="true"
                                                severity="danger"
                                                icon="pi pi-trash"
                                                (click)="confirmLoginDelete($event, login)"
                                            ></p-button>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="empty">
                                <tr>
                                    <td colspan="5" class="text-center p-4">No login information found.</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-popover #loginPopover [dismissable]="false">
    <div class="flex flex-col gap-3 p-1 min-w-[200px]" (mouseenter)="cancelHidePopover()" (mouseleave)="hideLoginPopover()">
        <div class="flex items-center justify-between gap-4">
            <span class="text-sm text-muted-color">User Name:</span>
            <div class="flex items-center gap-2">
                <span class="text-sm font-bold">{{ activeLoginInfo?.userName }}</span>
                <i
                    class="pi pi-copy text-primary cursor-pointer hover:text-primary-600"
                    (click)="copyToClipboard(activeLoginInfo?.userName)"
                ></i>
            </div>
        </div>
        <div class="flex items-center justify-between gap-4">
            <span class="text-sm text-muted-color">Password:</span>
            <div class="flex items-center gap-2">
                <span class="text-sm font-bold">{{ activeLoginInfo?.password }}</span>
                <i
                    class="pi pi-copy text-primary cursor-pointer hover:text-primary-600"
                    (click)="copyToClipboard(activeLoginInfo?.password)"
                ></i>
            </div>
        </div>
    </div>
</p-popover>

<p-dialog
    [header]="isEditMode ? 'Edit PSP' : 'New PSP'"
    [(visible)]="dialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '500px' }"
>
    <form [formGroup]="pspForm" (ngSubmit)="savePsp()">
        <div class="flex flex-col gap-4">
            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Definition *</label>
                <input
                    type="text"
                    pInputText
                    placeholder="Enter definition"
                    formControlName="text"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('text') }"
                />
                @if (isInvalid('text')) {
                    <small class="text-red-500">Definition is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Provider Type *</label>
                <p-select
                    [options]="serviceProviders"
                    formControlName="providerType"
                    placeholder="Select provider type"
                    appendTo="body"
                    [filter]="true"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('providerType') }"
                ></p-select>
                @if (isInvalid('providerType')) {
                    <small class="text-red-500">Provider type is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Payment Method *</label>
                <p-select
                    [options]="paymentMethods"
                    formControlName="paymentMethod"
                    placeholder="Select payment method"
                    [filter]="true"
                    appendTo="body"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('paymentMethod') }"
                ></p-select>
                @if (isInvalid('paymentMethod')) {
                    <small class="text-red-500">Payment method is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Tenant *</label>
                <p-select
                    [options]="tenantTypes"
                    formControlName="tenantId"
                    optionLabel="text"
                    optionValue="id"
                    placeholder="Select a tenant"
                    [filter]="true"
                    filterBy="text"
                    appendTo="body"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('tenantId') }"
                ></p-select>
                @if (isInvalid('tenantId')) {
                    <small class="text-red-500">Tenant is required.</small>
                }
            </div>

            @if (isEditMode) {
                <div class="flex items-center gap-2">
                    <p-toggleswitch formControlName="active" inputId="activeToggle"></p-toggleswitch>
                    <label for="activeToggle">Active</label>
                </div>
            }
        </div>
    </form>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" variant="outlined" (click)="cancelDialog()"></p-button>
            <p-button [label]="isEditMode ? 'Update' : 'Create'" (click)="savePsp()"></p-button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog
    [header]="isLoginEditMode ? 'Edit Login Info' : 'New Login Info'"
    [(visible)]="loginDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '500px' }"
>
    <form [formGroup]="loginForm" (ngSubmit)="saveLoginInfo()">
        <div class="flex flex-col gap-4">
            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Deep Link *</label>
                <input
                    type="text"
                    pInputText
                    placeholder="Enter deep link URL"
                    formControlName="deepLink"
                    [ngClass]="{ 'ng-invalid ng-dirty': isLoginInvalid('deepLink') }"
                />
                @if (isLoginInvalid('deepLink')) {
                    <small class="text-red-500">Deep link is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">User Name *</label>
                <input
                    type="text"
                    pInputText
                    placeholder="Enter user name"
                    formControlName="userName"
                    [ngClass]="{ 'ng-invalid ng-dirty': isLoginInvalid('userName') }"
                />
                @if (isLoginInvalid('userName')) {
                    <small class="text-red-500">User name is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Password *</label>
                <input
                    type="password"
                    pInputText
                    placeholder="Enter password"
                    formControlName="password"
                    [ngClass]="{ 'ng-invalid ng-dirty': isLoginInvalid('password') }"
                />
                @if (isLoginInvalid('password')) {
                    <small class="text-red-500">Password is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Additional Info</label>
                <input type="text" pInputText placeholder="Enter additional info" formControlName="additionalInfo" />
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" variant="outlined" (click)="cancelLoginDialog()"></p-button>
            <p-button [label]="isLoginEditMode ? 'Update' : 'Create'" (click)="saveLoginInfo()"></p-button>
        </div>
    </ng-template>
</p-dialog>
